import OverviewFlow from './OverviewFlow.vue'

export default {
  OverviewFlow
}



// WEBPACK FOOTER //
// ./src/components/FixWatersize/index.js